const carouselItems = [
  {
    title: '暑期档热门大片精选',
    desc: '炎炎夏日，宅家看大片。精选暑期最热高清电影，从动作大片到温情喜剧，一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20warm%20golden%20tones%2C%20cinematic%20action%20scene%2C%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20vibrant%20summer%20atmosphere&width=600&height=400&seq=carousel-1&orientation=landscape',
  },
  {
    title: '国产科幻崛起之路',
    desc: '从《流浪地球》到《三体》，国产科幻影视迎来黄金时代，高清全集一次看过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Sci-fi%20cinematic%20scene%20with%20futuristic%20elements%2C%20space%20and%20technology%20theme%2C%20warm%20neon%20accents%20on%20dark%20backdrop%2C%20epic%20scale%2C%20cinematic%20lighting&width=600&height=400&seq=carousel-2&orientation=landscape',
  },
  {
    title: '经典港片高清重制',
    desc: '那些年我们追过的港片经典，高清重制版本上线，重温黄金年代的银幕记忆。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20retro%20style%2C%20nostalgic%20film%20noir%20atmosphere%2C%20warm%20amber%20and%20crimson%20tones%2C%20old%20movie%20theater%20vibe%2C%20vintage%20film%20aesthetic&width=600&height=400&seq=carousel-3&orientation=landscape',
  },
  {
    title: '高分纪录片漫游世界',
    desc: '跟随顶级纪录片镜头，探索自然奇观、历史谜团与人文故事，足不出户看遍世界。',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20cinematography%20of%20natural%20wonders%20with%20warm%20sunset%20lighting%2C%20vast%20landscapes%2C%20golden%20hour%20tones%2C%20epic%20nature%20beauty%2C%20atmospheric&width=600&height=400&seq=carousel-4&orientation=landscape',
  },
  {
    title: '年度口碑剧集回顾',
    desc: '盘点全年豆瓣高分剧集，《繁花》《狂飙》《漫长的季节》等口碑佳作高清全集奉上。',
    img: 'https://readdy.ai/api/search-image?query=TV%20drama%20series%20award%20ceremony%20style%20composition%2C%20elegant%20indoor%20lighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20prestigious%20cinematic%20aesthetic%2C%20sophisticated%20mood&width=600&height=400&seq=carousel-5&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精选影视专题合集，发现更多观影灵感</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="aspect-[3/2] rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3 className="mt-3 text-sm font-medium text-foreground-800">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {carouselItems.slice(3).map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="aspect-[21/9] rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3 className="mt-3 text-sm font-medium text-foreground-800">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}